import styled from "styled-components";

export const CouponSwiperContainer = styled.div`
    max-width: ${(props) => {
        if (props.sidePanel) return "50%";
        if (props.numberOfSlides === 1) return "600px";
        else if (props.numberOfSlides === 2) return "1200px";
        return "100%";
    }};
    margin: 0 auto;
    flex: 1 0 ${(props) => (props.sidePanel ? "50%" : "100%")};

    .slick-arrow {
        opacity: 0;
        transition: opacity 200ms;
    }
    :hover {
        .slick-arrow {
            opacity: 1;
        }
    }

    @media (max-width: 768px) {
        flex: 1 0 100%;
        max-width: ${(props) => (props.sidePanel ? "50%" : "100%")};
    }
`;

export const Container = styled.div`
    display: flex;
    align-items: center;
    max-width: 100%;
    @media (max-width: 768px) {
        flex-wrap: wrap;
    }
`;
